/**
 * AI API 専用 fetch ラッパー
 *
 * 既存 useFetchToPublicWabunkaApi と同パターンだが、
 * チャットは完全クライアントサイドのため $fetch を使用する。
 *
 */
export interface UseFetchToWabunkaAiApiArgs<T> {
  path: string;
  body: Record<string, unknown>;
  converter: (res: unknown) => T;
  timeoutMs?: number;
}

// AI処理は応答に最大数分かかるため、LB・Cloud Runのタイムアウト(300s)と統一
const DEFAULT_TIMEOUT_MS = 300_000;

export const useFetchToWabunkaAiApi = () => {
  const runtimeConfig = useRuntimeConfig();

  const execute = async <T>({ path, body, converter, timeoutMs = DEFAULT_TIMEOUT_MS }: UseFetchToWabunkaAiApiArgs<T>): Promise<T> => {
    const response = await $fetch(path, {
      baseURL: runtimeConfig.public.WABUNKA_AI_API_BASE_URL as string,
      method: 'POST',
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body,
      signal: AbortSignal.timeout(timeoutMs),
    });
    return converter(response);
  };

  return { execute };
};
